import { Typography } from '@material-ui/core';
import HeadingTypography from './components/HeadingTypography';
import HeadingTitleTypography from './components/HeadingTitleTypography';
import HeadingSectionTypography from './components/HeadingSectionTypography';
import MutedTypography from './components/MutedTypography';
import QuoteTypography from './components/QuoteTypography';

const AgapeTypography = ({ variant, ...props }) => {
  if (variant === 'heading') {
    return <HeadingTypography {...props} />;
  }
  if (variant === 'heading-title') {
    return <HeadingTitleTypography {...props} />;
  }
  if (variant === 'heading-section') {
    return <HeadingSectionTypography {...props} />;
  }
  if (variant === 'muted') {
    return <MutedTypography {...props} />;
  }
  if (variant === 'quote') {
    return <QuoteTypography {...props} />;
  }
  return <Typography variant={variant} {...props} />;
};

export default AgapeTypography;
